import {createSlice} from '@reduxjs/toolkit';

interface MenuOpenState {
	open: boolean;
}

const initialState: MenuOpenState = {
	open: false,
};

const menuOpenSlice = createSlice({
	name: 'menuOpen',
	initialState,
	reducers: {
		clickOpenMenu: state => {
			state.open = !state.open;
		},
	},
});

export const {clickOpenMenu} = menuOpenSlice.actions;

export default menuOpenSlice.reducer;
